import { useState } from 'react';
import { anchors } from '@/mocks/home';

function AnchorCard({
  name,
  cover,
  tags,
  followers,
  note,
}: {
  name: string;
  cover: string;
  tags: string[];
  followers: string;
  note: string;
}) {
  const [followed, setFollowed] = useState(false);

  return (
    <article className="group rounded-lg overflow-hidden border border-background-200 bg-background-50">
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={cover}
          alt={`小蓝视频主播 ${name} 封面`}
          title={`小蓝视频主播 ${name}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-primary-500/95 text-background-50 text-[11px] font-label">
          <i className="ri-user-star-line"></i>
          主播
        </span>
        <div className="absolute left-3 right-3 bottom-3">
          <p className="font-heading text-lg font-bold text-background-50">{name}</p>
          <p className="mt-0.5 text-[11px] font-label text-background-200/90">
            {followers} 关注
          </p>
        </div>
      </div>

      <div className="p-4">
        <div className="flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs font-label text-foreground-500 leading-relaxed">{note}</p>
        <button
          type="button"
          onClick={() => setFollowed((value) => !value)}
          className={[
            'mt-4 w-full h-9 rounded-md text-sm font-label font-medium transition-colors cursor-pointer whitespace-nowrap',
            followed
              ? 'bg-background-100 text-foreground-600 border border-background-300'
              : 'bg-foreground-950 text-background-50 hover:bg-foreground-800',
          ].join(' ')}
        >
          {followed ? '已加入关注' : '关注该主播'}
        </button>
      </div>
    </article>
  );
}

export default function AnchorSpotlight() {
  return (
    <section id="anchors" className="bg-background-100 border-y border-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-label font-medium text-primary-600 tracking-wide mb-2">
              主播精选
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              先认识人，再挑内容
            </h2>
            <p className="mt-2 text-sm font-label text-foreground-600 max-w-xl">
              按封面快速浏览，看看每位主播擅长的领域和更新节奏，找到合眼缘的那一位。
            </p>
          </div>
          <a
            href="#topics"
            className="inline-flex items-center gap-1 text-sm font-label font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            用话题反向找主播
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-5">
          {anchors.map((anchor) => (
            <AnchorCard key={anchor.name} {...anchor} />
          ))}
        </div>
      </div>
    </section>
  );
}